module.exports = __webpack_public_path__ + "media/images/arrow-up-icon-822822bf3b7bb3468f871dbf65fa1f9c.svg";